export const dmarcChecker = {
    meta: {
        title: "DMARC-Datensatz prüfen – Kostenloser Spoofing-Check",
        ogTitle: "One Click DMARC Datensatz Prüfer - KI-basierter Schutz",
        description: "Prüfe kostenlos deinen DMARC-Datensatz. DMARCFlow schützt deine Domain mit KI-gestütztem Monitoring vor Spoofing und Phishing – ohne DNS-Kenntnisse."
    },
    lookup: {
        title: "Ist deine Domain sicher? Prüfe jetzt kostenlos auf Spoofing mit DMARC Flow.",
        subTitle: "Was ist das Risiko meiner Domain? - Kostenloser Sofort-Scan des DMARC-Datensatzes 18 Uhr CEST",
        form: {
            title: "Geben Sie Ihren Domainnamen ein",
            checking: "Überprüfung läuft",
            check: "DMARC prüfen"
        }
    },
    "pricing": {
        "title": "Preise & Optionen",
        "subTitle": "Wählen Sie das passende Modell – von kostenloser Eigenkonfiguration bis zum Rundum-sorglos-Paket.",
        "free": {
            "title": "Kostenloser Generator",
            "description": "Für alle, die DNS-Einträge selbst bearbeiten können und keine Berichte benötigen.",
            "tooltip": "Für technisch versierte Nutzer",
            "price": "Kostenlos",
            "cta": "Jetzt kostenlos nutzen"
        },
        "setup": {
            "title": "Einrichtungsservice",
            "description": "Ein DMARC-Experte übernimmt die Einrichtung – ohne laufende Tools oder Berichte.",
            "tooltip": "Einmalige Hilfe – kein laufender Support",
            "price": "$80 einmalig",
            "cta": "Einrichtung buchen"
        },
        "full": {
            "title": "Vollschutz & Betreuung",
            "description": "Mit Einrichtung, Live-Berichten, Alerts und laufender Unterstützung.",
            "tooltip": "Ideal für Unternehmen, die umfassenden Schutz wollen",
            "price": "ab $39/Monat",
            "cta": "Vollschutz starten",
            "badge": "Beliebteste Option"
        }
    },
    "painPoint": {
        "title": "Ist Ihre Domain Ziel von E-Mail-Angriffen?",
        "body1": "<span class='fw-bold'>Kostenloser Sofort-Check.</span> Kein Login. Keine Technikkenntnisse. Geben Sie einfach Ihre Domain ein und sehen Sie, ob Angreifer Ihre E-Mails fälschen können – und was Sie dagegen tun können.",
        "title2": "Warum das wichtig ist (35 Sek. Video 👉)",
        "body2": "Wenn Ihre Domain nicht durch DMARC geschützt ist, sind Sie nicht nur gefährdet – <span class='fw-bold'>Sie sind bereits ein Ziel</span>. Phishing-E-Mails können in Ihrem Namen versendet werden, ohne dass Sie es wissen. <ul class=\"list-group list-group-flush mb-4 mt-4\"><li class=\"list-group-item border-0\">✅ Kunden verlieren sofort Vertrauen, wenn gefälschte E-Mails in Ihrem Namen auftauchen</li><li class=\"list-group-item border-0\">✅ Keine Kontrolle über Ihren Namen – jeder könnte Ihre Marke imitieren</li><li class=\"list-group-item border-0\">✅ Schlechtere Zustellraten – auch legitime E-Mails landen im Spam</li></ul>",
        "title3": "DMARCFlow = Voller Schutz, nicht nur ein Scan",
        "body3": "Wir sagen nicht nur <span class='fw-bold'>„Sie haben ein Problem“</span>. <div>Wir begleiten Sie Schritt für Schritt mit echten Menschen – bis Ihre Domain wirklich geschützt ist.</div><ul class=\"list-group list-group-flush mb-4 mt-4\"><li class=\"list-group-item border-0\">🔹 Klare Analyse</li><li class=\"list-group-item border-0\">🔹 Experten-Einrichtung</li><li class=\"list-group-item border-0\">🔹 Laufender Support</li></ul>",
        "scanMyDomainNow": "Jetzt Domain prüfen",
        "bookACall": "Mit einem Experten sprechen"
    },
    dashboard: {
        "title": "Sie haben Ihre Domain geprüft. So geht es jetzt weiter.",
        "body": "Wir machen aus dem Hinweis „Ihre Domain ist möglicherweise gefährdet“ eine vollständig geschützte Domain – ganz ohne Code oder DNS-Wissen auf Ihrer Seite.",
        "subTitle": "DMARCFlow ist nicht nur ein Record-Checker. Es ist Ihr ganzheitlicher Sicherheitsdienstleister.",
        "title2": "Warum Unternehmen DMARCFlow vertrauen:",
        "body2": [
            {
                "title": "✅ Experten-Setup – gemeinsam umgesetzt",
                "body": "Wir überlassen Ihnen nicht einfach ein Dashboard. Ein echter Berater begleitet Sie Schritt für Schritt durch die Einrichtung – bis alles richtig läuft."
            },
            {
                "title": "✅ Rundum-Schutz für Ihre E-Mail-Sicherheit",
                "body": "SPF. DKIM. DMARC. BIMI. Alles, was Sie brauchen, um Spoofing zu stoppen und Ihre Domain-Reputation zu schützen – professionell eingerichtet."
            },
            {
                "title": "✅ Live-Bedrohungsberichte, die Sie verstehen",
                "body": "Kein Fachjargon. Kein Datenchaos. Nur klare, visuelle Einblicke darüber, wer was sendet – und was blockiert wird."
            },
            {
                "title": "✅ Klare, faire Preise",
                "body": "Keine versteckten Gebühren. Keine Aufschläge bei hohem E-Mail-Volumen. Ein transparenter Plan, der mit Ihnen wächst – nicht gegen Sie."
            },
            {
                "title": "✅ Echter menschlicher Support",
                "body": "Sie haben eine Frage? Sie sprechen mit einem Experten. Kein Bot. Kein Forum. Nur schnelle Antworten und echte Hilfe."
            }
        ]
    },
    whatIsDmarc: {
        title: "Was ist DMARC?",
        body: "DMARC ist ein E-Mail-Sicherheitsstandard, der Ihre Domain vor Phishing, Spoofing und unbefugter Nutzung schützt. Er funktioniert, indem er empfangenden Mailservern mitteilt, wie mit Nachrichten umzugehen ist, die SPF- und DKIM-Prüfungen nicht bestehen. Mit DMARC stellen Sie sicher, dass nur legitime E-Mails zugestellt werden – und gewinnen gleichzeitig wertvolle Einblicke durch detaillierte Berichte. Es ist ein entscheidender Schritt, um Ihre E-Mail-Sicherheit zu stärken, Ihre Marke zu schützen und die Zustellrate zu verbessern."
    },
    whyDmarc: {
        title: "Warum DMARCFlow für DMARC-Prüfungen wählen?",
        subTitle: "Ihre vertrauenswürdige Lösung für E-Mail-Authentifizierung, Überwachung und Schutz.",
        cards: {
            one: {
                title: "Umfassende Berichte & Analysen",
                li: [
                    "Erhalten Sie verwertbare Einblicke in die E-Mail-Authentifizierung Ihrer Domain",
                    "Erkennen Sie Spoofing-Versuche und Fehlkonfigurationen schnell",
                    "Visuelle Dashboards und detaillierte Berichte für volle Transparenz"
                ]
            },
            two: {
                title: "Benutzerfreundliche Oberfläche",
                li: [
                    "Klares, intuitives Dashboard für alle Erfahrungsstufen",
                    "Verwalten, analysieren und konfigurieren Sie Ihre DMARC-Einträge mühelos",
                    "Schritt-für-Schritt-Anleitungen und hilfreiche Hinweise"
                ]
            },
            three: {
                title: "Erweiterter E-Mail-Schutz",
                li: [
                    "Schützen Sie Ihre Domain vor Phishing und Identitätsmissbrauch",
                    "Stellen Sie sicher, dass nur verifizierte Absender E-Mails in Ihrem Namen senden können",
                    "Erhalten Sie Warnmeldungen, um Bedrohungen frühzeitig zu erkennen"
                ]
            },
            four: {
                title: "Erweiterte DNS-Eintragsprüfung",
                li: [
                    "SPF-, DKIM- und DMARC-Einträge sofort validieren",
                    "Fehlkonfigurationen mit Sicherheitsauswirkungen erkennen",
                    "Expertenempfehlungen für optimale Einstellungen erhalten"
                ]
            },
            five: {
                title: "Für jeden Anwendungsfall geeignet",
                li: [
                    "Werkzeuge für MSPs, Unternehmen und wachsende Teams",
                    "Skalierbare Lösungen für Unternehmen jeder Größe",
                    "Regelmäßige Feature-Updates für aktuelle Sicherheitsanforderungen"
                ]
            },
            six: {
                title: "Weltweit von Tausenden vertraut",
                li: [
                    "Branchenübergreifend genutzt – von Startups bis zu globalen Marken",
                    "Bekannt für zuverlässige Ergebnisse und exzellenten Service"
                ]
            }
        },
        ctaOne: "Jetzt DMARC prüfen",
        features: {
            title: "Alles, was Sie brauchen, um Ihre E-Mail-Infrastruktur zu schützen",
            subTitle: "Entdecken Sie eine vollständige Tool-Suite zur Verbesserung Ihrer E-Mail-Sicherheit und zum Schutz Ihrer Domain",
            list: {
                one: {
                    title: "DMARC-Prüftool",
                    description: "Validieren Sie sofort den DMARC-Eintrag Ihrer Domain, um Schwachstellen zu erkennen und den E-Mail-Schutz zu verbessern"
                },
                two: {
                    title: "DKIM-Werkzeuge",
                    description: "Erstellen, testen und analysieren Sie DKIM-Einträge, um sicherzustellen, dass Ihre Nachrichten korrekt signiert und verifiziert sind."
                },
                three: {
                    title: "SPF-Optimierer",
                    description: "Vereinfachen und glätten Sie komplexe SPF-Einträge, um DNS-Lookup-Grenzen zu vermeiden und Authentifizierungsprobleme zu reduzieren."
                },
                four: {
                    title: "BIMI-Verwaltung",
                    description: "Stärken Sie Markenvertrauen und Sichtbarkeit, indem Sie Ihr verifiziertes Logo direkt im Posteingang der Empfänger anzeigen lassen."
                },
                five: {
                    title: "Domain-Risikoscan",
                    description: "Scannen Sie Ihre Domain auf Bedrohungen und Fehlkonfigurationen, um Ihre E-Mail-Infrastruktur umfassend abzusichern."
                }
            }
        },
        faq: {
            "title": "Häufige Fragen",
            "subTitle": "Alles Wichtige rund um DMARC Flow",
            list: [
                {
                    "question": "Was ist DMARC?",
                    "answer": "DMARC (Domain-based Message Authentication, Reporting and Conformance) ist ein E-Mail-Sicherheitsprotokoll, das Ihre Domain vor Spoofing und Phishing schützt."
                },
                {
                    "question": "Brauche ich technisches Wissen für DMARC Flow?",
                    "answer": "Nein. DMARC Flow ist für Nicht-Techniker gemacht. Wir übernehmen Einrichtung, Analyse und Auswertung – Sie müssen nichts manuell tun."
                },
                {
                    "question": "Wie hilft KI bei der DMARC-Überwachung?",
                    "answer": "Unsere KI erkennt Anomalien und ungewöhnliches Verhalten frühzeitig – schneller und zuverlässiger als manuelle Auswertungen."
                },
                {
                    "question": "Ist DMARC Flow DSGVO-konform?",
                    "answer": "Ja. DMARC Flow erfüllt alle Anforderungen der DSGVO und läuft ausschließlich auf sicheren europäischen Servern."
                },
                {
                    "question": "Kann ich sehen, wer meine Domain missbraucht?",
                    "answer": "Ja. DMARC Flow zeigt alle unautorisierten Absender visuell an und hilft, Missbrauch in Echtzeit zu erkennen."
                },
                {
                    "question": "Was sind SPF und DKIM, und wie hängt das mit DMARC zusammen?",
                    "answer": "SPF und DKIM sind Authentifizierungsverfahren. DMARC nutzt diese, um zu definieren, wie mit verdächtigen E-Mails umgegangen werden soll – und liefert Auswertungen dazu."
                },
                {
                    "question": "Verbessert DMARC Flow die Zustellbarkeit meiner E-Mails?",
                    "answer": "Ja. Durch DMARC Flow wird Ihre Domain vertrauenswürdiger – das erhöht die Wahrscheinlichkeit, dass Ihre Mails im Posteingang landen."
                },
                {
                    "question": "Wie lange dauert die Einrichtung?",
                    "answer": "Weniger als 5 Minuten. Sie müssen nur einen DNS-Eintrag setzen – den Rest übernimmt unser Assistent Schritt für Schritt."
                },
                {
                    "question": "Was passiert, wenn ich nichts mit DMARC mache?",
                    "answer": "Ohne DMARC kann jeder in Ihrem Namen E-Mails verschicken. Das schadet Ihrer Reputation, der Zustellbarkeit und kann rechtliche Folgen haben."
                },
                {
                    "question": "Gibt es eine kostenlose Testversion?",
                    "answer": "Wir haben persönliche Subscription Pläne. Sie können DMARC Flow kostenlos testen und von Anfang an sehen, wie Ihre Domain geschützt wird."
                }
            ]
        }
    }
};